import React from 'react';
import { Inline, Stack, Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { SkeletonComponent as NavigationSkeleton } from '../horizontal-nav/index.tsx';

const HeaderSkeleton = () => (
	<Stack space="space.100" alignBlock="end" xcss={wrapperStyles}>
		<Inline spread="space-between">
			<Box xcss={primaryContainerStyles}>
				<Box xcss={[baseSkeletonStyles, squareStyles]} />
				<Box xcss={[baseSkeletonStyles, projectTitleStyles]} />
			</Box>
			<Inline space="space.150" xcss={actionStyles}>
				<Box xcss={[baseSkeletonStyles, squareStyles]} />
				<Box xcss={[baseSkeletonStyles, squareStyles]} />
			</Inline>
		</Inline>
		<NavigationSkeleton />
	</Stack>
);

export default HeaderSkeleton;

const wrapperStyles = xcss({
	paddingTop: 'space.300',
	minBlockSize: '96px',
});

const baseSkeletonStyles = xcss({
	backgroundColor: 'color.skeleton',
	borderRadius: 'border.radius',
});

const primaryContainerStyles = xcss({
	display: 'flex',
	gap: 'space.100',
	marginInlineStart: 'space.300',
});

const squareStyles = xcss({
	blockSize: token('space.300'),
	inlineSize: token('space.300'),
});

const projectTitleStyles = xcss({
	blockSize: token('space.300'),
	inlineSize: '180px',
});

const actionStyles = xcss({
	marginInlineEnd: 'space.300',
});
